var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu",
    {
      staticClass: "lang-switcher",
      attrs: {
        "md-active": _vm.isCardOpen,
        "md-align-trigger": "",
        "md-size": "huge",
        "md-direction": "bottom-end",
        "data-test-id": "lang-switcher"
      },
      on: {
        "update:mdActive": function($event) {
          _vm.isCardOpen = $event
        },
        "update:md-active": function($event) {
          _vm.isCardOpen = $event
        }
      }
    },
    [
      _c(
        "md-button",
        {
          staticClass: "lang-switcher__current",
          attrs: {
            "md-menu-trigger": "",
            "md-ripple": false,
            "data-test-id": "lang-switcher-btn"
          }
        },
        [
          _c("md-icon", {
            attrs: {
              "md-src": "/static/img/globe.svg",
              "data-test-id": "lang-switcher-btn-icon"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { "data-test-id": "lang-switcher-current-lang" } },
            [_vm._v("\n      " + _vm._s(_vm.getUserLocale) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-menu-content",
        {
          staticClass: "lang-switcher__options redesign-menu",
          attrs: { "data-test-id": "lang-switcher-list-container" }
        },
        _vm._l(_vm.locales, function(locale, idx) {
          return _c(
            "md-menu-item",
            {
              key: idx,
              staticClass: "lang-switcher__options-item",
              attrs: { "data-test-id": "lang-switcher-list-item-" + locale }
            },
            [
              _c(
                "button",
                {
                  attrs: {
                    "data-test-id": "lang-switcher-list-item-" + locale + "-btn"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setLocale(locale)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(locale) + "\n      ")]
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8554050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8554050","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/LangSwitcher.vue
// module id = XDKN
// module chunks = 1